<template>
  <v-container fluid class="batchdeposit-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Batch Deposit</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>
          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Deposit</p>
                        <v-select
                          class="mb-4"
                          :items=deposittype
                          v-model="new_batchdeposit.deposittype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the deposit type">
                        </v-select>
                        <v-menu
                          ref="menu_depositdate"
                          v-model="menu_depositdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_batchdeposit.depositdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_batchdeposit.depositdate"
                              label="Deposit Date"
                              v-bind="attrs"
                              v-bind:value="new_batchdeposit.depositdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the deposit date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_batchdeposit.depositdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_depositdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_depositdate.save(new_batchdeposit.depositdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="data_accounts"
                          v-model="new_batchdeposit.accountid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Account"
                          persistent-hint
                          single-line hint="Please choose the account">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {
                            return {text: x.locationname, value: x._id};
                            })"
                          v-model="new_batchdeposit.locationid"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-text-field
                          class="mb-4"
                          v-model="new_batchdeposit.refnum"
                          outlined
                          dense
                          placeholder="Reference Num"
                          persistent-hint
                          single-line hint="Enter the reference or description">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_batchdeposit.depositnote"
                          outlined
                          dense
                          placeholder="Note"
                          persistent-hint
                          single-line hint="Enter the note">
                        </v-text-field>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                              @click="cancelBatchDeposit"
                              replace
                              outlined
                              color="primary"
                          >
                            Cancel
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <p class="text-h5">Deposit Items</p>
                      <v-form>
                        <v-row justify="center">
                          <v-col cols="12" md="12">
                          <v-data-table
                            item-key="_id"
                            hide-default-footer
                            :headers="header_transactions"
                            :items="data_transactions"
                            :items-per-page="500"
                            class="elevation-0"
                          >
                            <template v-slot:item.transimage="{ item }">
                              <v-img
                              v-if="item.transimage" 
                              v-bind:src="item.transimage"
                              max-height="70"
                              max-width="70"
                              ></v-img>
                            </template>
                            <template v-slot:item.transnum="{ item }">
                              <p class="two-line">{{ item.transtype  }}</p>
                              <p class="two-line">{{ item.transnum  }}</p>
                              <p v-if="item.transdate!=undefined" class="two-line">{{ new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })  }}</p>
                            </template>
                            <template v-slot:item.transname="{ item }">
                              <p class="two-line">{{ item.transname }}</p>
                              <p class="two-line">{{ item.transaddress }}</p>
                              <p v-if="item.locationid!=undefined" class="two-line">{{ locations.length>0 ? locations.find(location=>location._id == item.locationid)['locationname'] : ''  }}</p>
                            </template>
                            <template v-slot:item.transaddress="{ item }">
                              {{ item.transaddress.toLocaleString('en-SG') }}
                            </template>
                            <template v-slot:item.transamount="{ item }">
                              <div style="margin-top: 35px; margin-bottom: 0; align-content: center;">
                                <v-text-field
                                  outlined
                                  dense
                                  persistent-hint
                                  class="mb-4"
                                  placeholder="Qty"  
                                  type="number"
                                  v-model="item.transamount"
                                  oninput="if(this.value < 1) this.value = 1;"
                                >
                                </v-text-field>            
                              </div>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="deleteOrder(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                            <template slot="body.append">
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th>Total</th>
                                  <th>{{ sum_amount }}</th>
                                  <th>{{ sum_deposit_amount }}</th>
                                  <th></th>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-col>
                        </v-row>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertBatchDeposit()">
                            Save
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';
import { sortDataAsc } from '@/util/tools';

export default {
  data () {
    return {
      errorindex: undefined,
      haserror: false,
      error: undefined,
      menu_depositdate: false,

      step: 1,
      item: {},
      edititem: {},
      isFrom: null,
      isSalesOrders: false,
      isInvoices: false,
      header_transactions: [
        { text: 'Image', value: 'transimage', width: '100px'},
        { text: 'Order', value: 'transnum' },
        { text: 'Customer', value: 'transname' },
        { text: 'Order Amount', value: 'transtotal', width: '12%' },
        { text: 'Deposit Amount', value: 'transamount', width: '12%' },
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      data_orders: [],
      data_transactions: [],
      deposittype: ['Batch Deposit'],
      new_batchdeposit: {},
      isDualCurrency: false,
      primaryCurrency: null,
      secondaryCurrency: null,
      currencyRate: null,
    }
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('BatchDeposit', ['batchdeposits', 'isReceiving']),
    ...mapState('Location', ['locations']),
    ...mapState('SystemSetting', ['settings']),
    sum_amount(){
      let result = this.data_transactions.reduce((a, b) => a + parseFloat(b.transtotal), 0);
      return isNaN(result) ? 0 : result;
    },
    sum_deposit_amount(){
      let result = this.data_transactions.reduce((a, b) => a + parseFloat(b.transamount), 0);
      return isNaN(result) ? 0 : result;
    },
    data_accounts(){
      let result = this.accounts.filter(account=>account.accountsubclass=='Bank');
      let filter = this.accounts.filter(account=>account.accountname.includes('Advance') || account.accountname.includes('Prepayment'));
      let results = [...result, ...filter];
      return results.map(x => { return {text: x.accountname, value: x._id} });
    },
  },
  methods: {
    ...mapActions('Account', ['getAccountsRequest']),
    ...mapActions('Order', ['getOrdersRequest']),
    ...mapActions('BatchDeposit', ['insertBatchDepositRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('SystemSetting', ["getSetting", "getSystemSettingsRequest"]),
    checkError(){
      if(this.data_transactions.length==0){
        this.haserrors = true;
        return false;
      }
      this.step = 2;
      this.errorindex = -1;
      return true;
    },
    checkError2(){
      this.step = 2;
      if(!this.new_batchdeposit.deposittype){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_batchdeposit.depositdate){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_batchdeposit.accountid){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_batchdeposit.locationid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    checkError3(){
      if(this.edititem.transaddress < this.edititem.transamount){
        this.haserrors = true;
        this.errorindex = 20;
        return false;
      }
      this.haserrors = false;
      this.errorindex = -1;
      return true;
    },
    deleteOrder(item){
      let index = this.findOrderIndexById(item._id);
      this.data_transactions.splice(index,1);
      this.calculateTotal();
    },
    findOrderIndexById(id){
      let index;
      if(this.data_transactions.find(item=>item._id==id)==null) {return -1}
      for(index=0; index<this.data_transactions.length; index++){
        if(this.data_transactions[index]._id==id){break;}
      }
      return index;
    },
    cancelBatchDeposit(){
      if(this.isSalesOrders==true){
        let orders = Object.assign([], this.$route.params.orders);
        let json = {orders: orders};
        router.push({ name: 'SalesOrderList', params: json });
        return;
      }
      if(this.isInvoices==true){
        let invoices = Object.assign([], this.$route.params.invoices);
        let json = {invoices: invoices};
        router.push({ name: 'InvoiceList', params: json });
        return;
      }
      else router.push('/batchdeposit/list');
    },
    async insertBatchDeposit() {
      if(!this.checkError2()) return;
      let json = {deposit: this.new_batchdeposit, transactions: this.data_transactions };
      await this.insertBatchDepositRequest(json);
      router.push('/batchdeposit/list');
    },
    onChangeDepositAmount(amount, payload){
      let item = Object.assign({}, payload, {transamount: amount});
      let index = this.data_transactions.findIndex(order=>order.id==payload.id);
      this.data_transactions.splice(index, 1, item);
    },
    arrangeSalesOrders(){
      sortDataAsc(this.data_orders, 'salesordernum')
      this.new_batchdeposit.isFrom = 'salesorder';
      this.new_batchdeposit.refnum = this.data_orders.length>0 ? this.data_orders[0].refnum : '';

      for(var i in this.data_orders){
        let order = this.data_orders[i];
        let trans = {};

        trans['id'] = order._id;
        trans['salesorderid'] = order._id;
        trans['locationid'] = order.locationid;
        trans['customerid'] = order.customerid;
        trans['transtype'] = order.salesordertype;
        trans['transnum'] = order.salesordernum;
        trans['refnum'] = order.refnum;
        trans['transdate'] = order.salesorderdate;
        trans['transname'] = order.salesordername;
        trans['transaddress'] = order.salesorderaddress;
        trans['transimage'] = order.salesorderimage;
        trans['transtotal'] = order.salesordertotal;
        trans['transamount'] = parseFloat(order.salesordertotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    },
    arrangeInvoices(){
      sortDataAsc(this.data_orders, 'invoicenum')
      this.new_batchdeposit.isFrom = 'invoice';
      this.new_batchdeposit.refnum = this.data_orders.length>0 ? this.data_orders[0].refnum : '';

      for(var i in this.data_orders){
        let order = this.data_orders[i];
        let trans = {};

        trans['id'] = order._id;
        trans['invoiceid'] = order._id;
        trans['locationid'] = order.locationid;
        trans['propertyid'] = order.propertyid;
        trans['customerid'] = order.customerid;
        trans['tenantid'] = order.tenantid;
        trans['transtype'] = order.invoicetype;
        trans['transnum'] = order.invoicenum;
        trans['refnum'] = order.refnum;
        trans['transdate'] = order.invoicedate;
        trans['transname'] = order.invoicename;
        trans['transaddress'] = order.invoiceaddress;
        trans['transimage'] = order.invoiceimage;
        trans['transtotal'] = order.invoicetotal;
        trans['transamount'] = parseFloat(order.invoicetotal.toFixed(2));
        this.data_transactions.push(trans);
      }
    }
  },
  async created () {
    let isInvoices = this.$route.params.isInvoices;
    let isSalesOrders = this.$route.params.isSalesOrders;

    this.data_orders = Object.assign([],this.$route.params.orders);
    if(!this.data_orders) this.$router.push({name: 'BatchDepositList'});
    if(isSalesOrders) this.arrangeSalesOrders();
    else if(isInvoices) this.arrangeInvoices();

    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
